module.exports = __webpack_public_path__ + "static/media/landing_course2.b0cca1cd.jpg";